import {Skeleton, Typography} from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';

const InfiniteScrollerCustom = ({hasMore, dataLength, next, children}) => {
  return (
    <InfiniteScroll
      style={{overflow: 'visible'}}
      dataLength={dataLength}
      next={() => next()}
      endMessage={
        <Typography.Text style={{display: 'block', textAlign: 'center', padding: 48}}>
          No more items to display
        </Typography.Text>
      }
      hasMore={hasMore}
      loader={<Skeleton active title={false} paragraph={{rows: 1}} style={{padding: '16px 0'}} />}>
      {children}
    </InfiniteScroll>
  );
};

InfiniteScrollerCustom.propTypes = {
  hasMore: PropTypes.bool.isRequired,
  dataLength: PropTypes.number.isRequired,
  next: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default InfiniteScrollerCustom;
